import {Component, Inject} from '@angular/core';
import {MAT_DIALOG_DATA, MatDialogRef} from '@angular/material/dialog';
import {Documento} from '../../shared/model/documentos.model';

@Component({
  selector: 'app-modal-view-documento',
  imports: [],
  templateUrl: './modal-view-documento.component.html',
  styleUrl: './modal-view-documento.component.css'
})
export class ModalViewDocumentoComponent {

  constructor(
    private dialog: MatDialogRef<ModalViewDocumentoComponent>,
    @Inject(MAT_DIALOG_DATA) public data: { documento: Documento }
  ) { }

  abrirLog() {
    this.dialog.close(this.data.documento);
  }
}
